import { Quill } from '@vueup/vue-quill'
import { WrapperBlot, WrappedBlot } from './blot_wrapper'

// --- Direct imports (no helper)
const Parchment     = Quill.import('parchment')
const Block         = Quill.import('blots/block')
const Inline        = Quill.import('blots/inline')
const TextBlot      = Quill.import('blots/text')
const Break         = Quill.import('blots/break')
const Embed         = Quill.import('blots/embed')

const CodeBlock     = Quill.import('formats/code-block')
const ListBlock     = Quill.import('formats/list') // base list export

// Try to grab sub-classes if your build exposes them
const ListContainer = ListBlock && ListBlock.Container ? ListBlock.Container : null
const ListItem      = ListBlock && ListBlock.Item      ? ListBlock.Item      : null

class ExpandContainer extends WrapperBlot {
    static blotName     = 'expand'
    static tagName      = 'aside'
    static className    = 'article-references'
    static defaultChild = 'expand-paragraph'
    static scope        = Parchment.Scope.BLOCK_BLOT | Parchment.Scope.CONTAINER

    optimize(context) {
        super.optimize(context)
        this._dedupeTitle()
    }

    replace(target) {
        super.replace(target)
        this._dedupeTitle()
    }

    _dedupeTitle() {
        const titles = this.domNode.getElementsByClassName('expand-title')
        for (let i = titles.length - 1; i >= 1; i--) titles[i].remove()
    }

    static create() {
        const node = super.create()
        if (!node.querySelector('.expand-title')) {
            const title = document.createElement('p')
            title.classList.add('expand-title')
            title.innerText = 'References'
            node.appendChild(title)
        }
        return node
    }

    static initCollapse(node) {
        node.classList.add('collapsed')
        node.addEventListener('click', () => node.classList.toggle('collapsed'))
    }
}

// Paragraph inside expand
class ExpandParagraph extends WrappedBlot {}
ExpandParagraph.blotName   = 'expand-paragraph'
ExpandParagraph.tagName    = 'p'
ExpandParagraph.className  = 'expand-paragraph'
ExpandParagraph.parentName = 'expand'

// Allow inlines + <br> + inline embeds (bold/italic/links + paste safety)
ExpandParagraph.allowedChildren = [Inline, TextBlot, Break, Embed]

// Keep title immutable
class ExpandTitle extends WrappedBlot { replaceWith() {} }
ExpandTitle.blotName   = 'expand-title'
ExpandTitle.tagName    = 'p'
ExpandTitle.className  = 'expand-title'
ExpandTitle.parentName = 'expand'

// Build allowed children list, covering all list variants
const allowed = [
    ExpandParagraph,
    ExpandTitle,
    Block,
    CodeBlock,
    // Prefer explicit container/item when present
    ListContainer,
    ListItem,
    // Fallback: allow base ListBlock (covers builds that only export this)
    ListBlock
].filter(Boolean)

// Deduplicate (in case ListContainer === ListBlock etc.)
ExpandContainer.allowedChildren = Array.from(new Set(allowed))

ExpandParagraph.requiredContainer = ExpandContainer
ExpandTitle.requiredContainer     = ExpandContainer

// Register
Quill.register(ExpandParagraph, true)
Quill.register(ExpandTitle, true)
Quill.register(ExpandContainer, true)

// Optional icon
export function initExpandSection() {
    const icons = Quill.import('ui/icons')
    icons['expand'] = '<div class="icon-expand" aria-hidden="true">Expand</div>'
}

export { ExpandContainer }
